export enum LinkType {
  External = "external",
  Internal = "internal",
  Email = "email",
}
